import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Paper from '@mui/material/Paper';

import { Loader } from 'ui';
import { EmptyDataLabel } from 'ui/Labels';

import { Item } from './Item/Item';

const PeopleList = ({ data, button, loading }) => {
  const { t } = useTranslation();

  return (
    <Paper>
      <List>
        {loading ? (
          <Loader center />
        ) : (
          data.map(({ id, name, position, languages }, index) => (
            <Fragment key={id}>
              <Item id={id} name={name} position={position} languages={languages} />
              {index + 1 < data.length && <Divider />}
            </Fragment>
          ))
        )}
        {!loading && data.length === 0 && (
          <EmptyDataLabel label={t('No other users logged in yet.')} />
        )}
        {!loading && button && (
          <ListItem>
            <Grid container justifyContent="center">
              {button}
            </Grid>
          </ListItem>
        )}
      </List>
    </Paper>
  );
};

PeopleList.defaultProps = {
  button: null,
  loading: false,
};

PeopleList.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      position: PropTypes.string.isRequired,
    }),
  ).isRequired,
  button: PropTypes.node,
  loading: PropTypes.bool,
};

export default PeopleList;
